<template>
  <div class="i-action-links" :class="{'disabled-icon' : isDisabled}">
    <span
      v-if="items"
      v-for="item in items"
    >
      <router-link
        v-if="!isDisabled"
        :to="goToUserDetailsPage(item?.pageName, userId, siteId, teamId, classroomId, item?.dataSet)"
        @click.native.stop
      >
        <i-tooltip :text="item.tooltipLabel" font-weight="bold" theme="dark">
          <template v-slot:tooltip-wrapper>
            <i-generate-image :image="isServiceDisabled(item) ? 'icons-disabled/' + item?.icon : item?.icon"/>
          </template>
        </i-tooltip>
      </router-link>

      <i-tooltip v-else :text="item.tooltipLabel" font-weight="bold" theme="dark">
          <template v-slot:tooltip-wrapper>
            <i-generate-image :image="item?.icon"/>
          </template>
        </i-tooltip>

    </span>
  </div>
</template>

<script>
import ITooltip from "@/components/common/ITooltip.vue";
import IGenerateImage from "@/components/common/IGenerateImage.vue";

export default {
  name: 'IActionLinks',
  components: {IGenerateImage, ITooltip},
  props: {
    items: {
      type: Array
    },
    userId: {
      type: String
    },
    id: {
      type: String
    },
    classroomId: {
      type: String
    },
    siteId: {
      type: String
    },
    teamId: {
      type: String
    },
    dataSet: {
      type: String
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    columnItem: {
      type: Object,
    },
  },

  data() {
    return {
      collectionMap: {
        gmail: 'gMail',
      }
    }
  },

  methods: {
    isServiceDisabled(item) {
      const serviceKey = this.collectionMap[item?.collection?.toLowerCase()] || item?.collection?.toLowerCase();
      return this.columnItem?.[serviceKey]?.isDisabled || false;
    },
    goToUserDetailsPage(name, userId, siteId, teamId, classroomId, dataSet) {
      if (!this.isDisabled) {
        let params = {
          dataSet: dataSet ? dataSet : null
        }
        if (userId) {
          params.userId = userId
        } else if (siteId) {
          params.siteId = siteId
        } else if (teamId) {
          params.teamId = teamId
        } else if (this.items[0].seatType === 'SharedDrive') {
          params.sharedDriveId = this.id
        } else if (this.items[0].seatType === 'Classroom') {
          params.classroomId = this.id
        } else if (this.items[0].seatType === 'SharedFolder') {
          params.sharedFolderId = this.id
        }

        return {
          name,
          params
        }
      }

    },
  }
}
</script>

<style lang="scss">
@import "IActionLinks";
</style>
